require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-poettelsdorf.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-poettelsdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-poettelsdorf!./.cache/json/betreuungseinrichtungen-mattersburg-poettelsdorf.json
// module id = 934
// module chunks = 231608221292675